import {
  type GetBoostedListingsResponse,
  type GetListingsWithBoostedStatusResponse,
} from './aliases';

export enum BoostOrigin {
  BoostedListings = 'boosted_listings',
  ProductPage = 'product_page',
  ShopPage = 'shop_page',
}

export interface Meta {
  cursor: string;
  hasMore: boolean;
}

export type BoostedListingRow = Omit<
  GetBoostedListingsResponse['objects'][number],
  'date_boost_created' | 'date_sold'
>;

export type SoldBoostedListingRow =
  GetBoostedListingsResponse['objects'][number];

export enum BoostedListType {
  All = 'all',
  Boosted = 'boosted',
}

export type ListingRowWithBoostedStatus =
  GetListingsWithBoostedStatusResponse['objects'][number];
